import React, { useCallback } from 'react'
import { makeStyles } from '@mui/styles'
import { Box, Theme, Typography } from '@mui/material'
import { ExtNode } from '../../../../screens/App/FamilyMember/FamilyTree/types'
import { nodeHeight, nodeWidth } from '../../../../screens/App/FamilyMember/FamilyTree/const'
import DateAndPlace from '../../../../screens/App/FamilyMember/FamilyTree/Templates/DateAndPlace'
import { Gender, MemberResponse } from '../../../../shared/types'
import { useSelector } from 'react-redux'
import { getMembers } from '../../../../store/data/data.selectors'
import BirthIcon from '../../../../shared/assets/icons/BirthIcon'
import DeathIcon from '../../../../shared/assets/icons/DeathIcon'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    display: 'flex',
    padding: '10px',
    overflow: 'hidden',
  },
  inner: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    border: '2px solid rgba(0, 0, 0, .2)',
    borderRadius: '10px 0',
    overflow: 'hidden',
    cursor: 'pointer',
    padding: '10px',
  },
  yellow: {
    backgroundColor: 'yellow',
  },
  red: {
    backgroundColor: 'red',
  },
  blue: {
    backgroundColor: 'blue',
  },
  violet: {
    backgroundColor: 'violet',
  },
  green: {
    backgroundColor: 'green',
  },
  orange: {
    backgroundColor: 'orange',
  },
  male: {
    color: 'white',
    // filter: 'brightness(60%)',
    backgroundColor: theme.palette.primary.dark,
  },
  female: {
    color: 'white',
    backgroundColor: theme.palette.primary.main,
  },
  isRoot: {
    borderColor: 'rgba(0, 0, 0, .4)',
  },
  isHover: {
    borderColor: 'rgba(0, 0, 0, .8)',
  },
  id: {
    fontSize: '7px',
    lineHeight: 1,
    opacity: 0.5,
  },
  sub: {
    position: 'absolute',
    top: '6px',
    right: '14px',
    width: '28px',
    height: '20px',
    border: '1px solid rgba(0, 0, 0, .2)',
    borderRadius: '4px 0',
    background: '#fff',
    cursor: 'pointer',
  },
}))

interface IFamilyNodeProps {
  node: ExtNode
  onClick?: (id: string) => void
}

const SingleFamilyNode: React.FC<IFamilyNodeProps> = ({ node, onClick }) => {
  const classes = useStyles()

  const members: MemberResponse | undefined = useSelector(getMembers)
  const activeMember = members?.results.find(member => member.id === node.id)
  const getNodeStyle = ({ left, top }: Readonly<ExtNode>) => {
    return {
      width: nodeWidth,
      height: nodeHeight,
      transform: `translate(${left && left * (nodeWidth / 2)}px, ${top && top * (nodeHeight / 2)}px)`,
    }
  }

  const clickHandler = useCallback(() => {
    onClick && node.id && onClick(node.id)
  }, [node.id, onClick])

  return (
    <Box className={classes.root} style={getNodeStyle(node)} onClick={() => clickHandler()}>
      <Box
        className={`${classes.inner} ${node.gender === Gender.female ? classes.female : classes.male} ${node.generation ? classes[node.generation] : ''}`}
      >
        <Box style={{ width: '100%' }}>
          <Box style={{ textAlign: 'left', marginLeft: '30px' }}>
            <Typography
              sx={{ lineHeight: 1.0, fontSize: '18px' }}
            ><b>{`${node.firstname} ${node.lastname}`}</b>
            </Typography>
          </Box>
          <Box sx={{ minHeight: '56px' }}>
            {activeMember?.birthname && activeMember?.showDetails &&
              <div style={{ textAlign: 'left', marginLeft: '30px' }}>
                <Typography
                  sx={{ lineHeight: 1.0, fontSize: '16px' }}
                >{`geb. ${activeMember.birthname}`}
                </Typography>
              </div>}
            {activeMember?.showDetails &&
              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Box sx={{ marginRight: '10px' }}>
                  <BirthIcon
                    color='#fff'
                    width='20px'
                  />
                </Box>
                <DateAndPlace
                  date={activeMember?.birthday}
                />
              </Box>}
            {activeMember?.showDetails && activeMember?.dead &&
              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Box
                  sx={{ marginRight: '10px' }}
                >
                  {activeMember.dead &&
                    <DeathIcon
                      color='#fff'
                      width='20px'
                    />}
                </Box>
                <DateAndPlace
                  date={activeMember?.deathday}
                />
              </Box>}
          </Box>
        </Box>
        <Box sx={{ height: 'auto', overflow: 'hidden' }}>
          <img
            style={{ width: '100%', height: 'auto' }}
            alt=''
            src={activeMember?.profileImage ? activeMember?.profileImage : `/profileImages/${activeMember?.id}.jpg`}
          />

        </Box>
      </Box>
      {node.hasSubTree && false && <Box className={classes.sub} />}
      {node.family === node.id && <Box className={classes.sub} />}
      {node.subFamily === node.id && <Box className={classes.sub} />}
    </Box>
  )
}

export default SingleFamilyNode
